import { render, staticRenderFns } from "./krasRiskRegisterTL.vue?vue&type=template&id=f0629720"
import script from "./krasRiskRegisterTL.vue?vue&type=script&lang=js"
export * from "./krasRiskRegisterTL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0629720')) {
      api.createRecord('f0629720', component.options)
    } else {
      api.reload('f0629720', component.options)
    }
    module.hot.accept("./krasRiskRegisterTL.vue?vue&type=template&id=f0629720", function () {
      api.rerender('f0629720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/timeline/krasRiskRegisterTL.vue"
export default component.exports